// extracted by mini-css-extract-plugin
export default {"breadcrumbContainer":"ContributorRoute_breadcrumbContainer__iY0ND"};